import React from 'react';
import Link from 'next/link';
import clsx from 'clsx';

interface PaginationProps {
  slug: string;
  currentPage: number;
  totalPages: number;
}

export const Pagination = ({ slug, currentPage, totalPages }: PaginationProps) => {
  const getPaginationRange = () => {
    const range = Math.floor((currentPage - 1) / 3) * 3;
    return Array.from({ length: totalPages }, (_, i) => i + 1).slice(range, range + 3);
  };

  return (
    <div className="flex gap-4 justify-center">
      {currentPage > 1 && (
        <Link
          href={
            currentPage - 1 === 1
              ? `/news/category/${slug}`
              : `/news/category/${slug}/${currentPage - 1}`
          }
          className="btn-yellow"
        >
          <span>Previous</span>
        </Link>
      )}

      {getPaginationRange().map((p) => (
        <Link
          key={p}
          href={p === 1 ? `/news/category/${slug}` : `/news/category/${slug}/${p}`}
          className={clsx("btn-yellow", currentPage === p && "btn-yellow__checked")}
          aria-disabled={currentPage === p}
          tabIndex={currentPage === p ? -1 : undefined}
        >
          <span>{p}</span>
        </Link>
      ))}

      {currentPage < totalPages && (
        <Link
          href={`/news/category/${slug}/${currentPage + 1}`}
          className="btn-yellow"
        >
          <span>Next</span>
        </Link>
      )}
    </div>
  );
};

export default Pagination;
